import { EnvMap } from "../../share/envVar/EnvMap"

const _map = new EnvMap()
/**
 * @dtsModule max.envVar
 * @dtsNamespace envVar
 * @dtsDesc envVar EnvVar
 */
export const envVar = {
  /**
   * @dtsExport
   */
  init: (map: { [key: string]: string }): void => {
    _map.init(map)
  },
  /**
   * @dtsExport
   * Get the entire environment variables
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.envVar.getMap&lang=%{locale}%)
   */
  getMap: (): { [key: string]: string } => {
    return _map.getMap()
  },
  /**
   * @dtsExport
   * Get environment variable for a specified key
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.envVar.getValue&lang=%{locale}%)
   */
  getValue: <T = any>(key: string): T => {
    return _map.get(key)
  },
}
